import { Component, Input, OnInit, ViewChild, Host, Optional, Injector } from '@angular/core';
import { FormControl, AbstractControl } from '@angular/forms';
import { EasyFormComponent } from '../form/form.component';
import { FMSUtilityService } from '../../services/utility/utility.service';
import { FormGroupComponent } from '../form-group/form-group.component';
import { FormErrorComponent } from '../error/error.component';
import { BaseInputComponent } from '../base-input/base-input.component';
import { LocalizePipe } from '../../../../pipes/Localize.pipe';

@Component({
    selector: 'imageUploadInput',
    templateUrl: 'image-upload-input.component.html',
    styleUrls: [
        '../base-input/base-input.component.css'
    ]
})
export class ImageUploadInputComponent extends BaseInputComponent implements OnInit {

    childOnInit() {

    }

    @Input() imageClass: any;
    @Input() allowedFileTypes: any;
    @Input() defaultUrl: any;


    get bindingElement() {
        return this.formControl && this.formControl.value;
    }
    set bindingElement(value) {
        this.formControl && this.formControl.setValue(value);
    }

    get familyId() { return 'input'; }

    constructor( @Host() parentForm: EasyFormComponent, @Optional() @Host() parentFormGroup: FormGroupComponent, protected injector: Injector) {
        super(parentForm, parentFormGroup, injector);
    }


}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/easyForms/components/image-upload-input/image-upload-input.component.ts